import { render, staticRenderFns } from "./view_HotSale.vue?vue&type=template&id=dd8761dc&scoped=true&"
import script from "./view_HotSale.vue?vue&type=script&lang=js&"
export * from "./view_HotSale.vue?vue&type=script&lang=js&"
import style0 from "./view_HotSale.vue?vue&type=style&index=0&id=dd8761dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8761dc",
  null
  
)

export default component.exports